import React from "react";
// SCSS
import "./services.scss";
// Assets
import Preview01 from "../../assets/blog/story01/services.png";
import Preview02 from "../../assets/blog/story01/services-arabic.png";
// Components
import Title from "../ui-components/title/title";

class Services extends React.Component {
  render() {
    const { language } = this.props;
    const translations = {
      en: {
        title: "SERVICES",
        description:
          "We offer a wide range of services to meet your needs. Whether you are looking for routine cleaning, deep cleaning, or specialized services, we have got you covered.",
      },
      ar: {
        title: "الخدمات",
        description:
          "نحن نقدم مجموعة واسعة من الخدمات لتلبية احتياجاتك. سواء كنت تبحث عن تنظيف روتيني أو تنظيف عميق أو خدمات متخصصة، فنحن هنا لتلبية احتياجاتك.",
      },
    };

    const isArabic = language === "ar";
    const imageToShow = isArabic ? Preview02 : Preview01;

    return (
      <div className="services" id="services">
        <div className="wrapper">
          <Title title={translations[language].title} />
          <p className="font14">{translations[language].description}</p>
          <div className="static-image">
            <img src={imageToShow} alt="Our Service Preview" />
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
